/*
 * @Author: Zhouqi
 * @Date: 2025-11-10 13:30:07
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-03 10:36:20
 */
import React from 'react';

interface LayoutProps {
  className?: string;
  children?: React.ReactNode;
}

const BasicComponent: React.FC<LayoutProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

interface RightComponentProps extends LayoutProps {
  style?: React.CSSProperties;
}

const RightComponent = React.forwardRef<HTMLDivElement, RightComponentProps>(
  ({ children, className, style }, ref) => (
    <div
      ref={ref}
      className={className}
      style={{
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        ...style,
      }}
    >
      {children}
    </div>
  ),
);

export interface GeneratorProps {
  className?: string;
  displayName?: string;
}

const generator =
  ({ displayName, className }: GeneratorProps) =>
  <P extends LayoutProps>(
    Component: React.ComponentType<P> | React.ForwardRefExoticComponent<P>,
  ) => {
    const Adapter = React.forwardRef<HTMLDivElement, P>((props, ref) => {
      const mergedClassName = props.className
        ? `${className} ${props.className}`
        : className;
      return <Component {...(props as P)} ref={ref} className={mergedClassName} />;
    });
    Adapter.displayName = displayName;

    return Adapter as React.ForwardRefExoticComponent<
      P & React.RefAttributes<HTMLDivElement>
    >;
  };

const baseClass = 'relative bg-[#ffffff] rounded-[8px] overflow-x-hidden';

export const Container = generator({
  displayName: 'Container',
  className: 'relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden',
})(BasicComponent);

export const Left = generator({
  displayName: 'Left',
  className: `w-[328px] ${baseClass}`,
})(BasicComponent);

export const Center = generator({
  displayName: 'Center',
  className: `flex-1 ml-[16px] ${baseClass}`,
})(BasicComponent);

export const Right = generator({
  displayName: 'Right',
  className: `flex-1 ml-[16px] ${baseClass}`,
})(RightComponent);

export const Introduction = generator({
  displayName: 'Introduction',
  className: `pl-[222px] ${baseClass}`,
})(BasicComponent);

export { default as RightWithAuth } from './RightWithAuth';
